import Core from 'handsontable/core';
import { CellProperties } from 'handsontable/settings';

import { prepareOptions } from 'SharedDir/service/fields/table.functions';

/**
 * Функция для отображения значений в ячейках - _Значения каталога_
 * @param instance
 * @param TD
 * @param row
 * @param col
 * @param prop
 * @param value
 * @param cellProperties
 * @constructor
 */
export default function CatalogRenderer(
  instance: Core,
  TD: HTMLTableCellElement,
  row: number,
  col: number,
  prop: string | number,
  value: any,
  cellProperties: CellProperties
) {
  if (!value) {
    return;
  }
  const { catalogLoaderPromise } = instance.getSettings();

  function resolveCatalogValue() {
    const { selectOptions = [], optionLabel = 'name', optionValue = 'id' } = cellProperties;
    let options;
    if (typeof selectOptions === 'function') {
      options = prepareOptions(selectOptions(row, col, prop));
    } else {
      options = prepareOptions(selectOptions);
    }
    const valueRecord = options.find((option) => option[optionValue] === value);
    if (!valueRecord) {
      TD.innerText = `Значение "${value}" не найдено в справочнике`;
    } else {
      TD.innerText = valueRecord[optionLabel];
    }
  }
  if (typeof catalogLoaderPromise === 'undefined') {
    resolveCatalogValue();
  } else {
    TD.innerText = 'Загружаем значения каталога ...';
    catalogLoaderPromise.then(resolveCatalogValue);
  }
}
